<template>
  <div v-if="visible" class="splash-screen">
    <div class="splash-content">
      <svg id="Layer_2" class="splash__logo" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 140.9 59.04">
        <g id="Layer_1-2" data-name="Layer 1">
          <path class="cls-5" d="M20.09,5.79c2.79,0,5.14,1.81,5.14,5.86v10.16h-4.36v-9.61c0-1.88-1.07-2.69-2.48-2.69-1.12,0-2.45.52-3.62,1.42.02.23.03.47.03.72v10.16h-4.36v-9.61c0-1.87-1.06-2.68-2.43-2.68-1.14,0-2.5.57-3.64,1.56v10.73H0V6.23h4.36v1.89c1.57-1.53,3.52-2.32,5.32-2.32s3.51.81,4.41,2.56c1.75-1.65,3.97-2.56,5.99-2.56h0Z"/>
          <path class="cls-5" d="M45.33,21.81h-4.36v-1.67c-1.56,1.46-3.34,2.11-5.02,2.11-3.96,0-6.73-3.65-6.73-8.23s2.77-8.23,6.73-8.23c1.68,0,3.46.64,5.02,2.11v-1.67h4.36v15.58ZM40.97,16.72v-5.39c-1.23-1.22-2.82-1.84-4.05-1.85-2.04,0-3.27,1.79-3.27,4.54s1.19,4.54,3.27,4.54c1.23,0,2.82-.62,4.05-1.85Z"/>
          <path class="cls-5" d="M60.38,5.77c.14,0,.28,0,.42.01l-.72,4.07c-.16-.01-.32-.02-.5-.02-1.71,0-3.65.69-5.27,2.03v9.94h-4.36V6.23h4.36v2.14c1.81-1.71,4.09-2.6,6.07-2.6h0Z"/>
          <path class="cls-5" d="M75.76,7.79l-1.66,2.67c-1.05-.93-2.79-1.39-4.36-1.4-1.32,0-2.32.44-2.4,1.45-.06.76.5,1.05,2.85,1.63,2.69.65,6.15,1.42,6.13,5.03-.01,3.78-3.82,5.07-7.02,5.07-2.55,0-5.28-.83-6.68-2.47l1.67-2.67c1,1.24,3.01,1.85,4.81,1.85,1.83,0,2.9-.66,2.92-1.67.01-1.02-1.07-1.21-3.01-1.71-3.93-1-5.96-1.83-5.96-4.77,0-3.71,3.25-5.02,6.52-5.02,2.09,0,4.6.55,6.2,1.99Z"/>
          <path class="cls-5" d="M95.35,11.65v10.16h-4.36v-9.61c0-1.86-1.14-2.69-2.61-2.68-1.22,0-2.68.58-3.91,1.6v10.69h-4.36V0h4.36v8.13c1.63-1.53,3.67-2.33,5.56-2.33,2.87,0,5.33,1.84,5.33,5.86Z"/>
          <path class="cls-5" d="M115.54,21.81h-4.36v-1.67c-1.56,1.46-3.34,2.11-5.02,2.11-3.96,0-6.73-3.65-6.73-8.23s2.77-8.23,6.73-8.23c1.68,0,3.46.64,5.02,2.11v-1.67h4.36v15.58ZM111.17,16.72v-5.39c-1.23-1.22-2.82-1.84-4.05-1.85-2.04,0-3.27,1.79-3.27,4.54s1.19,4.54,3.27,4.54c1.23,0,2.82-.62,4.05-1.85Z"/>
          <path class="cls-5" d="M124.67,16.47c0,1.64.83,2.24,1.97,2.24.34,0,.73-.07,1.15-.21l1.05,2.86c-1.2.56-2.48.89-3.66.89-2.62,0-4.87-1.48-4.87-5.22V0h4.36v16.47Z"/>
          <path class="cls-5" d="M136.72,16.47c0,1.64.83,2.24,1.97,2.24.34,0,.73-.07,1.15-.21l1.05,2.86c-1.2.56-2.48.89-3.66.89-2.62,0-4.87-1.48-4.87-5.22V0h4.36v16.47Z"/>
          <path class="cls-5" d="M15.08,45.02c-.01,5.24-3.2,8.23-6.82,8.23-1.95,0-3.99-.87-5.68-2.68v8.47H.67v-21.81h1.91v2.37c1.66-1.86,3.71-2.81,5.74-2.81,3.84,0,6.74,3.38,6.75,8.23ZM8.17,51.48c2.71-.02,4.92-2.19,4.92-6.46,0-3.98-2.06-6.41-4.91-6.41-1.76,0-3.89.9-5.59,2.91v6.92c1.74,2.03,3.78,3.06,5.59,3.05h0Z"/>
          <path class="cls-5" d="M29.13,36.77c.14,0,.28,0,.42.01l-.33,1.94c-.15-.01-.3-.02-.46-.01-1.98,0-4.12.85-6.15,2.83v11.27h-1.91v-15.58h1.91v2.56c2.12-2.09,4.41-3.02,6.52-3.02h0Z"/>
          <path class="cls-5" d="M36.44,32.96c0,.7-.57,1.27-1.27,1.27s-1.27-.57-1.27-1.27.57-1.27,1.27-1.27,1.27.57,1.27,1.27ZM34.22,52.81v-15.58h1.91v15.58h-1.91Z"/>
          <path class="cls-5" d="M55.77,42.65v10.16h-1.91v-10.16c0-2.73-1.64-4.06-3.76-4.06-1.72,0-3.88.87-5.65,2.64v11.58h-1.91v-15.58h1.91v2.31c1.87-1.9,4.12-2.75,6.02-2.75,2.87,0,5.3,1.92,5.3,5.86Z"/>
          <path class="cls-5" d="M71.2,52.18c-1.05.67-2.36,1.06-3.62,1.07-2.33.01-4.48-1.29-4.48-4.62v-9.45h-3.08v-1.24l2.9-.35h.19v-4.78h1.91v4.78h5.47v1.59h-5.47v9.45c0,2.16,1.39,2.9,2.95,2.9.94,0,1.92-.27,2.71-.66l.52,1.32Z"/>
          <g id="cross" class="cross">
            <rect class="cls-2" x="89.86" y="35.49" width="1.92" height="6.38"/>
            <rect class="cls-1" x="89.86" y="45.8" width="1.92" height="6.38"/>
            <rect class="cls-4" x="92.78" y="42.87" width="6.38" height="1.92"/>
            <rect class="cls-3" x="82.47" y="42.87" width="6.38" height="1.92"/>
          </g>
        </g>
      </svg>
      <h2 class="splash__message">From vision to reality</h2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SplashScreen',
  data() {
    return {
      visible: true
    };
  },
  methods: {
    rotate(group, angle, duration = 5000) {
      const { x, y, width, height } = group.getBBox();
      const cx = x + width / 2;
      const cy = y + height / 2;
      const start = performance.now();

      requestAnimationFrame(function step(time) {
        const t = Math.min((time - start) / duration, 1);
        const current = angle * t;
        group.setAttribute('transform', `rotate(${current}, ${cx}, ${cy})`);
        if (t < 1) requestAnimationFrame(step);
      });
    }
  },
  mounted() {
    const group = document.getElementById('cross');
    this.rotate(group, 540); // rotates 90° over 1 second
    setTimeout(() => {
      this.visible = false;
      this.$emit('splash-complete');
    }, 2000); // Show for 2 seconds
  }
}
</script>

<style lang="scss">
.splash-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: var(--darkblue);
  z-index: 3000;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 767px) {
    align-items: flex-start;
  }

  .splash-content {
    text-align: center;
    .cls-1 {fill: var(--orange);}
    .cls-2 {fill: var(--pink);}
    .cls-3 {fill: var(--green);}
    .cls-4 {fill: var(--lightblue);}
    .cls-5 {fill: var(--lightgrey);}
  }

  .splash__logo {
    width: 20rem;
    @media (max-width: 767px) {
      margin: 10rem auto 2rem auto;
    }
  }

  .splash__message {
    bottom: 5rem;
    color: var(--pink);
    font-family: 'gilroy-light', serif;
    font-weight: 300;
    margin: 0;
    position: absolute;
    right: 5rem;
    text-align: left;
    @media (max-width: 767px) {
      bottom: unset;
      left: 0;
      position: relative;
      right: unset;
      width: 20rem;
    }
  }

  .cross {
    position: relative;
  }
}
</style>
